export const tooltips = {
  ADD_ROW: 'הוספת שומה קיימת',
  EDIT_ROW: 'עריכת דוח ישן',
  EDIT_CUSTOMER: 'עריכת פרטי לקוח',
  DELETE_CUSTOMER: 'מחיקת לקוח',
  RESTORE_CUSTOMER: 'שחזור לקוח',
  VIEW_SHUMA: 'הצג טופס',
  PREVIEW_SHUMA: 'תצוגה מקדימה',
  EDIT_INSPECTION: 'עריכת פרטים כלליים עבור דוח זה',
  REDIRECT_TO_PLATFORM: 'עריכת הדוח עצמו בפלטפורמה',
  EDIT_PRICE_QUOTE: 'עריכה',
  DELETE_PRICE_QUOTE: 'מחיקה',
  DOWNLOAD_FILE: 'הורדה',
  CREATE_ORDER: 'יצירת הזמנה',
  EDIT_TASK: 'פרטים משימת',
  DELETE_TASK: 'מחיקה משימת',
  COPY_INSPECTION: 'שכפול דוח',
  DOWNLOAD_ALL_FILES: 'הורדת קבצי הדוח',
  EDIT_DOC: 'לערוך מסמך',
  EDIT_PAYMENT: 'עריכה',
  DELETE_CONTACT: 'מחיקת ליצור קשר',
  RESTORE_CONTACT: 'שחזור ליצור קשר',
  EDIT_CONTACT: 'עריכת איש קשר',
  PRICE_QUOTE_CREATE_CUSTOMER_LINK: 'יצירת לינק לאישור',
  DELETE_ORDER: 'מחיקה הזמנה',
  FREEZE_ORDER: 'הקפאה',
  UNFREEZE_ORDER: 'הוצאה מהקפאה',
  EDIT: 'עריכה',
  DELETE: 'עריכה',
  SHOW_EMAILS_HISTORY: 'הצג היסטוריית אימיילים',
  CREATE_INSPECTION_NOTE: 'הצגת עדכונים לדוח זה',
};
